module.exports = __webpack_public_path__ + "img/word-sence.0671759b.png";